/**
 * @desc 作废采购调价申请单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.PrcocurementOrderWorkflowRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/cancellationProcurementOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
